const isSMBPortal = (): boolean => {
  const smbDomains = [
    'dev-webmail-ui-chtr-commercial.mail.spectrumflow.net',
    'uat-webmail-ui-chtr-commercial.mail.spectrumflow.net',
    'mail3.spectrumbusiness.net',
    'mail3.stage-spectrumbusiness.net',
    'mail3-blue.spectrumbusiness.net',
    'mail3-green.spectrumbusiness.net',
  ];

  const url = new URL(window.location.href);
  if (smbDomains.includes(url.hostname)) {
    return true;
  }

  return ['commercial', 'smb', 'spectrumbusiness.net', 'commercial.mail.spectrumflow.net'].some((search) =>
    url.hostname.toLocaleLowerCase().includes(search)
  );
};

export { isSMBPortal };
